function customAtc(variantId, formId, quantity = 1) {
  fetch('/cart/add.js', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json'
    },
    body: JSON.stringify({
      id: variantId,
      quantity: quantity
    })
  })
  .then(response => response.json())
  .then(cart => {
    // Update cart count or other UI elements
    updateCartCount();
    // Optionally open the cart drawer
    openCartDrawer(variantId, formId);

  })
  .catch(error => {
    // Handle errors
    console.error('Error adding to cart:', error);
  });
}
function updateCartCount() {
  jQuery(document).ready(function ($) {
    var currentCartCount = parseInt($('#cw-cart-item-count').text());
    $('#cw-cart-item-count').text(currentCartCount + 1);
  });
}

function closeCartDrawer() {
  jQuery(document).ready(function ($) {
    // console.log('close custom atc modal fired!');
    $('body').removeClass('custom-atc-modal-active');
    $('#custom-atc-modal').html('');
  });
}

function openCartDrawer(variantId, formId) {
  jQuery(document).ready(function ($) {
    $('#custom-atc-modal').html('');
    var thisProdImgSrc = $('#' + formId).closest('.cpwo-inner').find('.bs-col-cpwo-image img').attr('src');
    var thisProdTitle = $('#' + formId).closest('.cpwo-inner').find('.cpwo-heading a').text();
    var thisProdVariantTitle = $('#' + formId).closest('.cpwo-inner').find('.cpwo-variant-readout-row.active .cpwo-variant-readout-row-title').text();
    var thisProdVariantPrice = $('#' + formId).closest('.cpwo-inner').find('.cpwo-variant-readout-row.active .cpwo-variant-readout-row-price').text();
    var htmlToAdd = `
      <div class="custom-atc-modal-title-row">
        <div id="custom-atc-modal-title">Added to Cart!</div>
        <div id="custom-atc-modal-close">X</div>
      </div>
      <div class="custom-atc-modal-inner">
        <div class="bs-row">
          <div class="bs-col custom-atc-modal-col-image">
            <img class="img-responsive" src="${thisProdImgSrc}" alt="Product Image" />
          </div>
          <div class="bs-col custom-atc-modal-col-content">
            <div class="custom-atc-modal-variant-title">${thisProdTitle}</div>
            <div class="custom-atc-modal-variant-info">
              <span class="custom-atc-modal-variant-info-title"><strong>${thisProdVariantTitle}</strong></span>
              <span class="custom-atc-modal-variant-info-price">${thisProdVariantPrice}</span>
            </div>
          </div>
        </div>
      </div>
    `;
    $('#custom-atc-modal').html(htmlToAdd);
    $('body').addClass('custom-atc-modal-active');
  });
}

jQuery(document).ready(function ($) {
    $('.slick-inline').slick();
    $('.carousel-tabs-section-widget ul.tabs li.tab label').click(function () {
        var thisTabNumber = $(this).attr('data-tab-number');
        var thisCarousel = $(this).closest('.tabs-group').find('.tab-content.tab-content-' + thisTabNumber + ' .slick-inline');
        if ($(thisCarousel).hasClass('needs-slick-re-init')) {
            $(thisCarousel).slick('unslick');
            $(thisCarousel).slick();
            $(thisCarousel).removeClass('needs-slick-re-init');
        }
    });
    $('.carousel-tabs-section-widget .tab-content > h3 > label').click(function () {
        var thisCarousel = $(this).closest('.tab-content').find('.slick-inline');
        if ($(thisCarousel).hasClass('needs-slick-re-init')) {
            $(thisCarousel).slick('unslick');
            $(thisCarousel).slick();
            $(thisCarousel).removeClass('needs-slick-re-init');
        }
    });
    $('.cpwo-variants select').on('change', function(){
        // console.log('value changed! 1');
        var cpwoVal = $(this).val();
        $(this).closest('.cpwo-form').find('.cpwo-variant-readout-row').removeClass('active');
        $(this).closest('.cpwo-form').find('.cpwo-variant-readout-row[data-v-id="' + cpwoVal + '"]').addClass('active');
    });
    $('.cpwo-variant-readout-row').on('click', function(){
        var thisVariantID = $(this).attr('data-v-id');
        $(this).closest('.cpwo-variants').find('.cpwo-select').val(thisVariantID);
        $(this).closest('.cpwo-form').find('.cpwo-variant-readout-row').removeClass('active');
        $(this).addClass('active');
    });
    $('.cpwo-form form').on('submit', function(e){
      e.preventDefault();
      var variantId = $(this).closest('.cpwo-form').find('.cpwo-select').val();
      var thisFormId = $(this).attr('id');
      customAtc(variantId, thisFormId);
    });
    $('#custom-atc-backdrop').click(function(){
      closeCartDrawer();
    });
    if(jQuery().colorbox) {
        $('.c2e img').each(function(){
            var thisImgSrc = $(this).attr('src');
            $(this).wrap('<a href="' + thisImgSrc + '" class="c2e-link"></a>');
            if($(this).closest('.c2e').hasClass('with-tag')){
                $('<span class="c2e-text">+ CLICK TO ZOOM</span>').insertAfter($(this));
            }
        });
        $("a.c2e-link").colorbox({maxWidth:'95%',maxHeight:'95%'});
    }
});
jQuery(document.body).on('click', '#custom-atc-modal-close', function(event) {
  closeCartDrawer();
});
